export interface cancellationPayloadTypes {
  vehicleId?: number;
  notes: string;
  reasons: string[];
  executeReturnVehicle?: true;
}

export interface ecoGraphUrlPayload {
  forecastId: string;
  currentOfferLabel: string;
}

export interface MoneyBackBadgeProps {
  daysLeft: number;
  isExpired: boolean;
  expirationDate: string;
  isInViewport: boolean;
  backgroundColor?: string;
  foregroundColor?: string;
  customClassName?: string;
  customStyles?: {};
}

export interface MoneyBackProgressBarProps {
  daysLeft: number;
  isExpired: boolean;
  isInViewport: boolean;
  backgroundColor?: string;
  foregroundColor?: string;
  customClassName?: string;
  customStyles?: {};
}

export interface TrackGapCoverageCardClickedProps {
  ctaClicked: boolean;
  contactAllyClicked: boolean;
}

export const CUSTOMER_REGISTRATION_EXPERIMENT_NAME = 'regops-my-cars-customer-registration-component';

export enum BannerDisplayMode {
  DEFAULT = 'DEFAULT',
  INTERACTIVE = 'INTERACTIVE',
}
